import DynamicModuleGenerator from '../../dynamic-module-generator';
import { Accordion } from '../accordion/accordion';

export type ExpandableContentProps = {
    heading?: string;
    content?: any;
};

export const ExpandableContent = (props: ExpandableContentProps) => {
    return (
        <Accordion heading={props.heading ?? ''}>
            <DynamicModuleGenerator
                content={props.content}
                skipSectionConversion={true}
            />
        </Accordion>
    );
};

ExpandableContent.parseProps = (atts: any) => {
    return {
        heading: atts.heading,
        content: atts.content,
    };
};
